import * as _ from "lodash";
import { ElementType, IElement } from "../model/IProcessData";
import { ValidationError, ValidationErrorType } from "../model/ValidationData";
import { USE_STATEMENT_MODE } from "processEditor/model/ElementFactory";

export function hasValidationError(validation: ValidationError[] | undefined, validationErrorType: ValidationErrorType): boolean {
    const error = _.find(validation, { messageType: validationErrorType });
    return error !== undefined;
}

export function getElementName(type: ElementType): string {
    switch (type) {
        case ElementType.CallActivity:
            return "Call Subprocess";
        case ElementType.Catch:
            return "Catch";
        case ElementType.ConditionBranch:
            return "Exclusive Condition Branch";
        case ElementType.Decision:
            return "Exclusive Decision";
        case ElementType.Expression:
            return "Code";
        case ElementType.InclusiveDecisionBranch:
            return "Inclusive Condition Branch";
        case ElementType.InclusiveGateway:
            return "Inclusive Decision";
        case ElementType.IntermediateReturn:
            return "Intermediate Return";
        case ElementType.ParallelForeach:
        case ElementType.SequentialForeach:
            return "Foreach";
        case ElementType.Start:
        case ElementType.SubProcessStartNode:
            return "Start";
        case ElementType.Return:
            return "Return";
        case ElementType.SequenceFlow:
            return "Sequence Flow";
        case ElementType.Task:
            return "Task";
        case ElementType.SubProcess:
            return "Scope";
        case ElementType.Throw:
            return "Throw";
        case ElementType.While:
            return "While";
        case ElementType.GlobalErrorHandler:
            return FRENDS.Localizations.ProcessErrorHandler;
        case ElementType.Dmn:
            return "DMN task";
        case ElementType.NativeAi:
            return "AI Connector";
        case ElementType.SharedState:
            return "Shared state task";
        case ElementType.DataObjectReference:
            return "Data Object reference";
        case ElementType.DataStoreReference:
            return "Data Store reference";
        case ElementType.HydrationPoint:
            return "Checkpoint";
        case ElementType.ScheduledRehydration:
            return "Scheduled resume";
        case ElementType.SignalRehydration:
            return "Signal resume";
        default:
            return "";
    }
}

export function getElementDocumentationIdentifier(element: IElement): string {
    switch (element.type) {
        case ElementType.Expression: {
            const usingStatementMode = element.parameters[USE_STATEMENT_MODE]?.["value"]
            return usingStatementMode ? "Code Statement" : "Code";
        }
        default: {
            return getElementName(element.type);
        }
    }
}
